var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOttoPeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 86,
    viewBox: "0 0 171 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.732 40.5031C121 43.9999 123.955 38.7823 139.5 38.9999C155.95 39.2301 156.669 34.6209 162.5 33.4999C168.331 32.3789 150.67 14.7473 129 20.4999C115.089 24.1928 106.463 37.0063 113.732 40.5031Z",
    fill: "#AEA075"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.475 75.9998C147.703 73.9153 146.878 71.8177 146 69.7087C127.136 24.3994 97.9237 24.4018 87.4463 24.4026L87.3143 24.4026C72.6661 24.4026 39.0365 40.8753 30.8881 75.9998H148.475Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4114 51.3682C74.0132 54.0256 69.8636 52.9039 66.7208 54.7982C63.578 56.6926 62.6319 60.8857 61.0302 58.2283C59.4284 55.5709 61.5478 53.3244 64.6906 51.4301C67.8335 49.5357 70.8096 48.7108 72.4114 51.3682Z",
    fill: "#3D3D3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.363 48.9287C104.546 52.0285 108.126 49.6573 111.533 50.556C114.941 51.4547 116.886 55.2829 117.703 52.1832C118.521 49.0835 115.977 47.5259 112.57 46.6272C109.162 45.7285 106.181 45.829 105.363 48.9287Z",
    fill: "#3D3D3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1765 29.5536C59.0445 33.0968 39.8808 63.579 39.8808 63.579L33.1289 75.8795C33.1289 75.8795 17.3252 72.7514 21.1143 51.1533C23.36 38.3526 53.3085 26.0104 56.1765 29.5536Z",
    fill: "url(#paint1_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.304 76C115.824 58.4193 99.2556 40.2493 87.2059 43.3194C75.019 46.4245 70.044 57.138 64.1345 69.8638C63.2045 71.8666 62.2513 73.9193 61.2432 76L123.304 76Z",
    fill: "url(#paint2_linear)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 28.5146C115.2 35.047 124.723 28.2971 140.268 28.5146C156.719 28.7448 163.169 39.5351 169 38.4141C174.831 37.2931 150.229 7.57254 128 10.4999C102.232 13.8934 103.8 21.9822 109.5 28.5146Z",
    fill: "#C7B886"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.613 47.0534C101.469 51.8294 96.9032 60.7826 90.1299 61.9963C83.3566 63.2101 76.9407 56.2249 76.0849 51.4489C75.229 46.6729 80.4909 44.4115 87.2642 43.1978C94.0374 41.984 99.7572 42.2774 100.613 47.0534Z",
    fill: "#3D3D3D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.20822 73.0304C2.47041 65.4726 12.3633 53.3282 23.0816 53.7001C33.7999 54.0719 41.2849 66.8192 41.0227 74.3769C40.7605 81.9347 31.0942 79.872 20.3759 79.5001C9.65756 79.1283 1.94603 80.5882 2.20822 73.0304Z",
    fill: "#CDBF91"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.343 73.4528C168.075 65.7356 157.973 53.3351 147.029 53.7148C136.085 54.0944 128.442 67.1106 128.71 74.8277C128.977 82.5449 138.556 79.8798 149.5 79.5001C160.444 79.1204 168.61 81.1699 168.343 73.4528Z",
    fill: "#CDBF91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 49.2432,
    y: 26.9778,
    width: 86.061,
    height: 57.0221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 0,
    y: 53.0001,
    width: 43.7176,
    height: 32.3789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 126,
    y: 53,
    width: 44.541,
    height: 32.5452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 89.6815,
    y1: 24.4026,
    x2: 89.6815,
    y2: 75.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#CDBF90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6996E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 47.2165,
    y1: 31.422,
    x2: 27.5517,
    y2: 74.0378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#C7B886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89864"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 89,
    y1: 43.9999,
    x2: 89,
    y2: 86.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#BDB085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#897E5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOttoPeek);
export default __webpack_public_path__ + "static/media/otto-peek.4d7023d4d6e995ee2f0876771ce99845.svg";
export { ForwardRef as ReactComponent };